module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "mdl-layout__content"
  }, [(_vm.section) ? _c('div', {
    staticClass: "page-content"
  }, [_c('h1', {
    staticClass: "mdl-typography--headline",
    domProps: {
      "textContent": _vm._s(_vm.translate(_vm.section.captionNumbered))
    }
  }), _vm._v(" "), (_vm.isApiReport) ? _c('div', {
    staticClass: "summary-text"
  }, [_c('label', {
    staticClass: "mdl-data-table__cell--non-numeric"
  }, [_vm._v("Description of damage")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.report.damage_description),
      expression: "report.damage_description",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "mdl-textfield__input",
    domProps: {
      "value": (_vm.report.damage_description)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.report, "damage_description", $event.target.value)
      }, function($event) {
        return _vm.saveReportForm()
      }]
    }
  })]) : _vm._e(), _vm._v(" "), _vm._l((_vm.section.categories), function(category) {
    return [_c('h2', {
      staticClass: "mdl-typography--title"
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(_vm.translate(category.caption))
      }
    }), _vm._v(" "), (_vm.isEditable()) ? _c('button', {
      staticClass: "btnUpdAnswers mdl-button mdl-js-button mdl-button--icon green",
      on: {
        "click": function($event) {
          return _vm.updateAnswers($event, category)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons"
    }, [_vm._v("done_all")])]) : _vm._e()]), _vm._v(" "), _c('table', {
      staticClass: "mdl-data-table mdl-shadow--2dp",
      staticStyle: {
        "width": "100%"
      }
    }, [_c('tbody', [_vm._l((category.items), function(item) {
      return [_c('tr', {
        class: [_vm.getStateColor(item.state)]
      }, [_c('td', {
        staticClass: "mdl-data-table__cell--non-numeric\tcaptionNumbered",
        domProps: {
          "textContent": _vm._s(item.caption_numbered)
        }
      }), _vm._v(" "), _c('td', {
        staticClass: "mdl-data-table__cell--non-numeric",
        domProps: {
          "textContent": _vm._s(_vm.translate(item.caption))
        }
      }), _vm._v(" "), (_vm.isEditable()) ? _c('td', [_c('button', {
        staticClass: "mdl-button mdl-js-button mdl-button--icon blue",
        on: {
          "click": function($event) {
            return _vm.copyEmptyItem(item)
          }
        }
      }, [_c('i', {
        staticClass: "material-icons"
      }, [_vm._v("add")])]), _vm._v(" "), _c('button', {
        staticClass: "mdl-button mdl-js-button mdl-button--icon green",
        on: {
          "click": function($event) {
            return _vm.changeAnswerState(item, 1)
          }
        }
      }, [_c('i', {
        staticClass: "material-icons"
      }, [_vm._v("done")])]), _vm._v(" "), (!_vm.isEuropcarReport()) ? _c('button', {
        staticClass: "mdl-button mdl-js-button mdl-button--icon yellow",
        on: {
          "click": function($event) {
            return _vm.changeAnswerState(item, 0)
          }
        }
      }, [_c('i', {
        staticClass: "material-icons"
      }, [_vm._v("error_outline")])]) : _vm._e(), _vm._v(" "), _c('button', {
        staticClass: "mdl-button mdl-js-button mdl-button--icon red",
        on: {
          "click": function($event) {
            return _vm.changeAnswerState(item, -1)
          }
        }
      }, [_c('i', {
        staticClass: "material-icons"
      }, [_vm._v("close")])])]) : _vm._e()]), _vm._v(" "), (1) ? _c('tr', {
        staticClass: "item-assessment-report",
        class: [_vm.getStateColor(item.state)],
        on: {
          "change": function($event) {
            return _vm.saveAnswers([item])
          }
        }
      }, [_c('td', {
        attrs: {
          "colspan": "3"
        }
      }, [_c('form', [_c('div', {
        staticClass: "item-assessment-report_image-placeholder"
      }, [(item.images) ? _c('div', {
        staticClass: "images"
      }, _vm._l((item.images), function(image, imageIndex) {
        return _c('div', {
          style: (image ? {
            backgroundImage: 'url(' + (image ? image : '') + ')'
          } : ''),
          on: {
            "click": function($event) {
              return _vm.$root.showLightbox(item.images, imageIndex)
            }
          }
        }, [_c('label', {
          staticClass: "mdl-button mdl-js-button mdl-button--icon image-delete",
          on: {
            "click": function($event) {
              $event.preventDefault();
              $event.stopPropagation();
              return _vm.removeAnswerImage(item, imageIndex)
            }
          }
        }, [_c('i', {
          staticClass: "material-icons",
          staticStyle: {
            "color": "white !important"
          }
        }, [_vm._v("delete")])]), _vm._v(" "), _c('label', {
          staticClass: "mdl-button mdl-js-button mdl-button--icon image-open",
          on: {
            "click": function($event) {
              return _vm.$root.showLightbox(item.images, imageIndex)
            }
          }
        }, [_c('i', {
          staticClass: "material-icons",
          staticStyle: {
            "color": "white !important"
          }
        }, [_vm._v("open_with")])])])
      }), 0) : _vm._e(), _vm._v(" "), (_vm.isEditable()) ? _c('label', {
        staticClass: "mdl-button mdl-js-button mdl-button--icon",
        attrs: {
          "for": 'item-image' + item.id
        }
      }, [_c('input', {
        staticClass: "photo-camera-input",
        attrs: {
          "id": 'item-image' + item.id,
          "type": "file",
          "accept": "image/*"
        },
        on: {
          "change": function($event) {
            $event.preventDefault();
            $event.stopPropagation();
            return _vm.uploadImage($event, item)
          }
        }
      }), _vm._v(" "), _c('i', {
        staticClass: "material-icons"
      }, [_vm._v("photo_camera")])]) : _vm._e()]), _vm._v(" "), _c('div', {
        staticClass: "item-assessment-report_description"
      }, [_c('div', {
        staticClass: "mdl-textfield mdl-js-textfield textSelector",
        staticStyle: {
          "width": "100%",
          "display": "block"
        }
      }, [(_vm.isEditable()) ? _c('v-select', {
        attrs: {
          "onChange": function(val) {
            val.content = _vm.translate(val.content);

            _vm.onAutoReplySelect(item, val)
          },
          "placeholder": "Merknad",
          "label": "content",
          "options": _vm.grouped_items_replies
        },
        scopedSlots: _vm._u([{
          key: "option",
          fn: function(ref) {
            var content = ref.content;
            var title = ref.title;

            return [(content) ? _c('div', [_vm._v(_vm._s(_vm.translate(content)))]) : _c('div', {
              attrs: {
                "disabled": "disabled"
              },
              on: {
                "click": function($event) {
                  $event.stopPropagation();
                  return (function(e) {
                    return false
                  }).apply(null, arguments)
                }
              }
            }, [_c('b', {
              domProps: {
                "textContent": _vm._s(_vm.translate(title))
              }
            })])]
          }
        }], null, true),
        model: {
          value: (item.description),
          callback: function($$v) {
            _vm.$set(item, "description", $$v)
          },
          expression: "item.description"
        }
      }) : _vm._e(), _vm._v(" "), _c('textarea', {
        directives: [{
          name: "model",
          rawName: "v-model.lazy",
          value: (item.description),
          expression: "item.description",
          modifiers: {
            "lazy": true
          }
        }],
        staticClass: "mdl-textfield__input",
        attrs: {
          "disabled": !_vm.isEditable(),
          "type": "text",
          "rows": "1",
          "id": 'description' + item.id
        },
        domProps: {
          "value": (item.description)
        },
        on: {
          "change": function($event) {
            return _vm.$set(item, "description", $event.target.value)
          }
        }
      }), _vm._v(" "), _c('label', {
        staticClass: "mdl-textfield__label",
        attrs: {
          "for": 'description' + item.id
        },
        domProps: {
          "textContent": _vm._s(_vm.translate('Standard skadebeskrivelse'))
        }
      })], 1), _vm._v(" "), _c('div', {
        staticClass: "mdl-textfield mdl-js-textfield",
        staticStyle: {
          "width": "100%",
          "display": "block"
        }
      }, [_c('textarea', {
        directives: [{
          name: "model",
          rawName: "v-model.lazy",
          value: (item.condition_value),
          expression: "item.condition_value",
          modifiers: {
            "lazy": true
          }
        }],
        staticClass: "mdl-textfield__input",
        attrs: {
          "disabled": !_vm.isEditable(),
          "type": "text",
          "rows": "1",
          "id": 'condition_value' + item.id
        },
        domProps: {
          "value": (item.condition_value)
        },
        on: {
          "change": function($event) {
            return _vm.$set(item, "condition_value", $event.target.value)
          }
        }
      }), _vm._v(" "), _c('label', {
        staticClass: "mdl-textfield__label",
        attrs: {
          "for": 'condition_value' + item.id
        }
      }, [(item.condition_measurement) ? [_c('span', {
        domProps: {
          "textContent": _vm._s(_vm.translate('Skadebeskrivelse/Måleverdi') + ' (' + item.condition_measurement + ')')
        }
      })] : [_c('span', {
        domProps: {
          "textContent": _vm._s(_vm.translate('Skadebeskrivelse/Måleverdi'))
        }
      })]], 2)]), _vm._v(" "), _c('div', {
        staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label",
        staticStyle: {
          "width": "100%",
          "display": "none"
        }
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model.lazy",
          value: (item.estimate),
          expression: "item.estimate",
          modifiers: {
            "lazy": true
          }
        }],
        staticClass: "mdl-textfield__input",
        attrs: {
          "disabled": !_vm.isEditable(),
          "pattern": "[0-9]*(\\.[0-9]{1,2})?",
          "type": "text",
          "id": 'estimate' + item.id
        },
        domProps: {
          "value": (item.estimate)
        },
        on: {
          "change": function($event) {
            return _vm.$set(item, "estimate", $event.target.value)
          }
        }
      }), _vm._v(" "), _c('label', {
        staticClass: "mdl-textfield__label",
        attrs: {
          "for": 'estimate' + item.id
        },
        domProps: {
          "textContent": _vm._s(_vm.translate('Pris/Verdireduksjon'))
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "mdl-textfield__error",
        domProps: {
          "textContent": _vm._s(_vm.translate('Input må være et tall'))
        }
      })]), _vm._v(" "), _vm._l((item.lineitems), function(lineitem) {
        return (_vm.$root.isSurveyorCapability()) ? _c('div', [_c('div', {
          staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label lineItemDesc textSelector",
          style: (_vm.isWithoutPrice() ? {
            width: '100%'
          } : {})
        }, [('en' === _vm.report.report_language) ? _c('div', [(_vm.isEditable()) ? _c('v-select', {
          attrs: {
            "onChange": function(val) {
              _vm.onLineItemSelect(item, lineitem, val)
            },
            "placeholder": "Merknad",
            "label": "description_en",
            "options": _vm.line_item_descriptions
          },
          model: {
            value: (lineitem.description_en),
            callback: function($$v) {
              _vm.$set(lineitem, "description_en", $$v)
            },
            expression: "lineitem.description_en"
          }
        }) : _vm._e(), _vm._v(" "), _c('textarea', {
          directives: [{
            name: "model",
            rawName: "v-model.lazy",
            value: (lineitem.description_en),
            expression: "lineitem.description_en",
            modifiers: {
              "lazy": true
            }
          }],
          staticClass: "mdl-textfield__input",
          attrs: {
            "disabled": !_vm.isEditable(),
            "type": "text",
            "rows": "1",
            "id": 'linedescription' + lineitem.id
          },
          domProps: {
            "value": (lineitem.description_en)
          },
          on: {
            "change": [function($event) {
              return _vm.$set(lineitem, "description_en", $event.target.value)
            }, function($event) {
              return _vm.onLineItemChange(lineitem)
            }]
          }
        }), _vm._v(" "), _c('label', {
          staticClass: "mdl-textfield__label",
          attrs: {
            "for": 'linedescription' + lineitem.id
          },
          domProps: {
            "textContent": _vm._s(_vm.translate('Beskrivelse av verdireduksjon'))
          }
        })], 1) : ('da' === _vm.report.report_language) ? _c('div', [(_vm.isEditable()) ? _c('v-select', {
          attrs: {
            "onChange": function(val) {
              _vm.onLineItemSelect(item, lineitem, val)
            },
            "placeholder": "Merknad",
            "label": "description_da",
            "options": _vm.line_item_descriptions
          },
          model: {
            value: (lineitem.description_da),
            callback: function($$v) {
              _vm.$set(lineitem, "description_da", $$v)
            },
            expression: "lineitem.description_da"
          }
        }) : _vm._e(), _vm._v(" "), _c('textarea', {
          directives: [{
            name: "model",
            rawName: "v-model.lazy",
            value: (lineitem.description_da),
            expression: "lineitem.description_da",
            modifiers: {
              "lazy": true
            }
          }],
          staticClass: "mdl-textfield__input",
          attrs: {
            "disabled": !_vm.isEditable(),
            "type": "text",
            "rows": "1",
            "id": 'linedescription' + lineitem.id
          },
          domProps: {
            "value": (lineitem.description_da)
          },
          on: {
            "change": [function($event) {
              return _vm.$set(lineitem, "description_da", $event.target.value)
            }, function($event) {
              return _vm.onLineItemChange(lineitem)
            }]
          }
        }), _vm._v(" "), _c('label', {
          staticClass: "mdl-textfield__label",
          attrs: {
            "for": 'linedescription' + lineitem.id
          },
          domProps: {
            "textContent": _vm._s(_vm.translate('Beskrivelse av verdireduksjon'))
          }
        })], 1) : ('sv' === _vm.report.report_language) ? _c('div', [(_vm.isEditable()) ? _c('v-select', {
          attrs: {
            "onChange": function(val) {
              _vm.onLineItemSelect(item, lineitem, val)
            },
            "placeholder": "Merknad",
            "label": "description_sv",
            "options": _vm.line_item_descriptions
          },
          model: {
            value: (lineitem.description_sv),
            callback: function($$v) {
              _vm.$set(lineitem, "description_sv", $$v)
            },
            expression: "lineitem.description_sv"
          }
        }) : _vm._e(), _vm._v(" "), _c('textarea', {
          directives: [{
            name: "model",
            rawName: "v-model.lazy",
            value: (lineitem.description_sv),
            expression: "lineitem.description_sv",
            modifiers: {
              "lazy": true
            }
          }],
          staticClass: "mdl-textfield__input",
          attrs: {
            "disabled": !_vm.isEditable(),
            "type": "text",
            "rows": "1",
            "id": 'linedescription' + lineitem.id
          },
          domProps: {
            "value": (lineitem.description_sv)
          },
          on: {
            "change": [function($event) {
              return _vm.$set(lineitem, "description_sv", $event.target.value)
            }, function($event) {
              return _vm.onLineItemChange(lineitem)
            }]
          }
        }), _vm._v(" "), _c('label', {
          staticClass: "mdl-textfield__label",
          attrs: {
            "for": 'linedescription' + lineitem.id
          },
          domProps: {
            "textContent": _vm._s(_vm.translate('Beskrivelse av verdireduksjon'))
          }
        })], 1) : _c('div', [(_vm.isEditable()) ? _c('v-select', {
          attrs: {
            "onChange": function(val) {
              _vm.onLineItemSelect(item, lineitem, val)
            },
            "placeholder": "Merknad",
            "label": "description",
            "options": _vm.line_item_descriptions
          },
          model: {
            value: (lineitem.description),
            callback: function($$v) {
              _vm.$set(lineitem, "description", $$v)
            },
            expression: "lineitem.description"
          }
        }) : _vm._e(), _vm._v(" "), _c('textarea', {
          directives: [{
            name: "model",
            rawName: "v-model.lazy",
            value: (lineitem.description),
            expression: "lineitem.description",
            modifiers: {
              "lazy": true
            }
          }],
          staticClass: "mdl-textfield__input",
          attrs: {
            "disabled": !_vm.isEditable(),
            "type": "text",
            "rows": "1",
            "id": 'linedescription' + lineitem.id
          },
          domProps: {
            "value": (lineitem.description)
          },
          on: {
            "change": [function($event) {
              return _vm.$set(lineitem, "description", $event.target.value)
            }, function($event) {
              return _vm.onLineItemChange(lineitem)
            }]
          }
        }), _vm._v(" "), _c('label', {
          staticClass: "mdl-textfield__label",
          attrs: {
            "for": 'linedescription' + lineitem.id
          },
          domProps: {
            "textContent": _vm._s(_vm.translate('Beskrivelse av verdireduksjon'))
          }
        })], 1)]), _vm._v(" "), (!_vm.isWithoutPrice()) ? _c('div', {
          staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label lineItemCost"
        }, [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model.lazy",
            value: (lineitem.cost),
            expression: "lineitem.cost",
            modifiers: {
              "lazy": true
            }
          }],
          staticClass: "mdl-textfield__input sectionItemCostColumn",
          attrs: {
            "disabled": !_vm.isEditable() || _vm.isWithoutPrice(),
            "pattern": "[0-9]*(\\.[0-9]{1,2})?",
            "type": "text",
            "id": 'lineitem_cost' + lineitem.id
          },
          domProps: {
            "value": (lineitem.cost)
          },
          on: {
            "change": function($event) {
              return _vm.$set(lineitem, "cost", $event.target.value)
            }
          }
        }), _vm._v(" "), _c('label', {
          staticClass: "mdl-textfield__label",
          attrs: {
            "for": 'lineitem_cost' + lineitem.id
          },
          domProps: {
            "textContent": _vm._s(_vm.translate('Pris'))
          }
        }), _vm._v(" "), _c('span', {
          staticClass: "mdl-textfield__error",
          domProps: {
            "textContent": _vm._s(_vm.translate('Input må være et tall'))
          }
        })]) : _vm._e()]) : _vm._e()
      }), _vm._v(" "), (_vm.$root.isSurveyorCapability()) ? _c('div', [_c('div', {
        staticClass: "mdl-button mdl-js-button mdl-button--icon green newlineitem-button",
        on: {
          "click": function($event) {
            return _vm.addLineItem(item)
          }
        }
      }, [_c('i', {
        staticClass: "material-icons"
      }, [_vm._v("playlist_add")])])]) : _vm._e()], 2)])])]) : _vm._e()]
    })], 2)]), _vm._v(" "), (_vm.isEditable() && !_vm.section.inspection_off) ? _c('button', {
      staticClass: "mdl-button mdl-button--raised",
      staticStyle: {
        "float": "right",
        "margin": "10px"
      },
      on: {
        "click": function($event) {
          return _vm.addCustomImage(category)
        }
      }
    }, [_vm._v("Legg til ekstra bilde")]) : _vm._e()]
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "tab-bar"
  }, [_c('button', {
    staticClass: "mdl-button mdl-js-button mdl-button--raised mdl-button--colored-grey",
    on: {
      "click": _vm.previous
    }
  }, [_vm._v("Lukk")]), _vm._v(" "), (_vm.isRegularReport()) ? _c('button', {
    staticClass: "mdl-button mdl-js-button mdl-button--raised mdl-button--colored-blue",
    attrs: {
      "disabled": _vm.$root.ui.isLoading('sendAnswers')
    },
    on: {
      "click": _vm.deliver
    }
  }, [_vm._v("Avslutt innlevering")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "mdl-button mdl-js-button mdl-button--raised mdl-button--colored-green",
    attrs: {
      "disabled": _vm.$root.ui.isLoading('sendAnswers')
    },
    domProps: {
      "textContent": _vm._s(_vm.isRentalReport() ? 'Til rapport' : 'Videre')
    },
    on: {
      "click": _vm.next
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-13fd5e6a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./reports/assets/src/components/ReportImages.vue
// module id = 62
// module chunks = 0